<template>
    <div class="renew-edit-bg" @click="close()" v-show="showTemplate">
        <div class="renew-edit-content" @click.stop="notDoAnything">
            <div class="renew-edit-title">
                修改自动付费
                <img src="../assets/x.svg" alt="" @click="close()">
            </div>
            <div class="renew-edit-items">
                <div class="renew-edit-item">
                    <div class="key">当前有效时间</div>
                    <div class="value">2018-10-20</div>
                </div>
                <div class="renew-edit-item">
                    <div class="key">下次扣费时间</div>
                    <div class="value">2018-10-19</div>
                </div>
                <div class="renew-edit-item">
                    <div class="key">扣费金额</div>
                    <div class="value">¥ 20</div>
                </div>
                <div class="renew-edit-item">
                    <div class="key">默认支付方式</div>
                    <div class="value">微信支付</div>
                </div>
            </div>
            <div class="cancel-auto-renew-btn" @click="cancelAutoRenewFun">取消自动续费</div>
        </div>
    </div>
</template>

<script>
export default {
  name: "RenewEdit",
  props: {
    show: {
      type: Boolean,
      value: true
    }
  },
  data() {
    return {
      showTemplate: this.show
    };
  },
  watch: {
    show: function(value, oldValue) {
      console.log(value, oldValue);
      this.showTemplate = value;
    }
  },
  methods: {
    close: function() {
      console.log("aaa");
      this.showTemplate = false;
      this.$emit("hideRenewEdit");
    },
    notDoAnything: function() {
      return 0;
    },
    cancelAutoRenewFun: function() {
      console.log("取消自动续费");
      this.$emit("cancelAutoRenew", { cancelOk: true });
    }
  }
};
</script>

<style scoped lang="scss">
.renew-edit-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  .renew-edit-content {
    width: 100%;
    height: 5.64rem;
    background: #fff;
    position: absolute;
    bottom: 0;
    .renew-edit-title {
      height: 0.7rem;
      line-height: 0.7rem;
      text-align: center;
      color: #232220;
      font-size: 0.26rem;
      position: relative;
      border-bottom: 0.01rem solid #eeeeee;
      img {
        height: 0.23rem;
        width: 0.23rem;
        position: absolute;
        top: 0.2rem;
        left: 0.14rem;
      }
    }
    .renew-edit-items {
      width: 100%;
      padding-left: 0.3rem;
      box-sizing: border-box;
      .renew-edit-item {
        height: 0.76rem;
        width: 100%;
        line-height: 0.76rem;
        border-bottom: 0.01rem solid #eeeeee;
        padding-right: 0.3rem;
        box-sizing: border-box;
        font-size: 0.22rem;
        .key {
          float: left;
          color: #65635e;
        }
        .value {
          float: right;
          color: #212121;
        }
      }
    }
    .cancel-auto-renew-btn {
      width: 4.8rem;
      height: 0.58rem;
      border-radius: 0.08rem;
      background: linear-gradient(
        -90deg,
        rgba(240, 222, 172, 1),
        rgba(218, 185, 127, 1)
      );
      line-height: 0.58rem;
      font-size: 0.22rem;
      color: #232220;
      box-shadow: 0 0.14rem 0.11rem -0.06rem rgba(221, 184, 122, 0.5);
      position: fixed;
      left: 50%;
      margin-left: -2.4rem;
      bottom: 0.3rem;
    }
  }
}
</style>
